import { render, staticRenderFns } from "./CampaignSideBar.vue?vue&type=template&id=05b4a1e0&scoped=true&"
import script from "./CampaignSideBar.vue?vue&type=script&lang=ts&"
export * from "./CampaignSideBar.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSideBar.vue?vue&type=style&index=0&id=05b4a1e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4a1e0",
  null
  
)

export default component.exports